// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1Dup0191M3V66B {\n  padding: 6px 5px 0 6px;\n}\n@media only screen and (max-width: 750px) {\n  ._1Dup0191M3V66B {\n    padding-top: 18px;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quickSwitcherContainer": "_1Dup0191M3V66B"
};
export default ___CSS_LOADER_EXPORT___;
